import { render, staticRenderFns } from "./ProHome.vue?vue&type=template&id=3c070cc4&"
import script from "./ProHome.vue?vue&type=script&lang=js&"
export * from "./ProHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports